import UAParser from 'ua-parser-js';

export default class UserAgent {
  static isMobileOrTabletUAString() {
    const parser = new UAParser();
    const { type } = parser.getDevice();
    const { name } = parser.getOS();
    const iPadOS = window.orientation !== undefined && name === 'Mac OS';
    return type === 'tablet' || type === 'mobile' || iPadOS;
  }
}
